import Card from "@mui/material/Card";
import SoftBox from "../../../components/SoftBox";
import {useParams} from "react-router-dom";
import {getAdminById} from "../../../api/admin/adminApiClient";
import React, {useEffect, useState} from "react";
import {CardContent, Chip, CircularProgress, Grid, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import AdminInfo from "./AdminInfo";

function AdminDetailPage() {
    const theme = useTheme();
    const {adminId} = useParams();
    const [admin, setAdmin] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const loadAdminDetails = async () => {
        setLoading(true);
        setError(null);
        console.log('Loading admin details for ID:', adminId);

        try {
            const res = await getAdminById(adminId);
            console.log('Admin API response:', res);
            const adminData = res.data;
            setAdmin(adminData);
        } catch (error) {
            console.error("Failed to load admin details:", error);
            if (error.response?.status === 403) {
                setError("Access denied. You don't have permission to view admin details.");
            } else if (error.response?.status === 401) {
                setError("Authentication required. Please log in again.");
            } else if (error.response?.status === 404) {
                setError("Admin not found.");
            } else {
                setError("Failed to load admin details. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (adminId) {
            loadAdminDetails();
        }
    }, [adminId]);

    if (loading) {
        return (
            <SoftBox display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress/>
            </SoftBox>
        );
    }

    return (
        <SoftBox>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <SoftBox display="flex" flexDirection="column" alignItems="center" p={2}>
                                <SoftBox
                                    component="img"
                                    src={admin.profilePic ? `data:image/png;base64,${admin.profilePic}` : undefined}
                                    alt="Admin Profile"
                                    sx={{
                                        width: 150,
                                        height: 150,
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: `3px solid ${theme.palette.grey[300]}`,
                                        mb: 2
                                    }}
                                />
                                <Typography variant="h5" gutterBottom>
                                    {admin.firstName} {admin.lastName}
                                </Typography>
                                <Chip
                                    label={admin.userRole || 'ADMIN'}
                                    color="primary"
                                    variant="outlined"
                                    sx={{mb: 1}}
                                />
                                <Chip
                                    label={admin.status || 'ACTIVE'}
                                    color={admin.status === 'ACTIVE' ? 'success' : 'error'}
                                    variant="outlined"
                                />
                            </SoftBox>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={8}>
                    <AdminInfo admin={admin}/>
                </Grid>
            </Grid>
        </SoftBox>
    );
}

export default AdminDetailPage;

